export const setUnScrollBody = () => {
    document.body.style.overflowY = "hidden";
}

export const removeUnScrollBody = () => {
    document.body.style.overflowY = "initial";
}